export interface ChatMessage {
  role: 'user' | 'model' | 'live_transcription';
  parts: { text: string }[];
  isLive?: boolean;
}

export interface ChatHistoryEntry {
  id: string;
  interview_id: string;
  role: string;
  content: string;
  timestamp: string;
  message_order: number;
}

export interface User {
  id: string;
  name: string;
  email?: string;
  password?: string;
  created_at: string;
  last_active: string;
}

export enum InterviewPhase {
  GET_STARTED = "GET_STARTED",
  INTRODUCTION_AND_BACKGROUND = "INTRODUCTION_AND_BACKGROUND",
  METHODOLOGY_OVERVIEW = "METHODOLOGY_OVERVIEW", 
  SCENARIO_AND_TACIT_KNOWLEDGE = "SCENARIO_AND_TACIT_KNOWLEDGE"
}

export enum InterviewStatus {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  ABORTED = "ABORTED"
}

export interface StartInterviewRequest {
  user_id?: string;
  user_name?: string;
  email?: string;
}

export interface ValidateCredentialsRequest {
  username: string;
  password: string;
}

export interface ValidateCredentialsResponse {
  success: boolean;
  message: string;
  user?: User;
}

export interface StartInterviewResponse {
  interview_id: string;
  user_id: string;
  user_name?: string;
  bot_message: string;
  interview_status: InterviewStatus;
  current_phase: InterviewPhase;
}

export interface RespondResponse {
  bot_message: string;
  interview_status: InterviewStatus;
  current_phase: InterviewPhase;
}

export interface GetInterviewStateResponse {
  interview_id: string;
  user_id: string;
  user_name?: string;
  interview_status: InterviewStatus;
  current_phase: InterviewPhase;
  chat_history: ChatHistoryEntry[];
  current_question_id?: string;
  start_time?: string;
  elapsed_time_minutes: number;
}

export interface InterviewProgress {
  completed_questions: number;
  total_questions: number;
  remaining_questions: number;
  progress_percentage: number;
  current_phase: string;
  current_question: string | null;
  follow_up_count: number;
  total_follow_ups: number;
}

export const PHASE_DISPLAY_NAMES = {
  [InterviewPhase.GET_STARTED]: "Getting Started",
  [InterviewPhase.INTRODUCTION_AND_BACKGROUND]: "Introduction & Background",
  [InterviewPhase.METHODOLOGY_OVERVIEW]: "Methodology Overview", 
  [InterviewPhase.SCENARIO_AND_TACIT_KNOWLEDGE]: "Scenario and Tacit Knowledge"
};

export const PHASE_TIMING = {
  [InterviewPhase.GET_STARTED]: 2,
  [InterviewPhase.INTRODUCTION_AND_BACKGROUND]: 5,
  [InterviewPhase.METHODOLOGY_OVERVIEW]: 15,
  [InterviewPhase.SCENARIO_AND_TACIT_KNOWLEDGE]: 25
};

export type VoiceSettingsType = {
  speed: number;
  volume: number;
  pitch: number;
}; 